import { Check, Sparkles, X } from "lucide-react";
import { Reveal, SectionHead } from "./shared";

const TRADITIONAL = [
    "Works limited hours",
    "Needs training",
    "Can miss messages",
    "Needs time off",
    "Handles one task at a time",
];

const AI_EMPLOYEE = [
    "Works 24/7",
    "Follows your instructions",
    "Responds instantly",
    "Never misses a follow-up",
    "Handles thousands of conversations",
];

const Avatar = () => (
    <div className="relative w-64 h-64 sm:w-80 sm:h-80 mx-auto" data-testid="ai-avatar-visual">
        <div className="absolute inset-0 rounded-full border border-cyan-400/15 spin-slow">
            <span className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-2 h-2 rounded-full bg-cyan-400 shadow-[0_0_12px_rgba(0,240,255,0.8)]" />
        </div>
        <div className="absolute inset-8 rounded-full border border-cyan-400/25 spin-slow-rev">
            <span className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 w-1.5 h-1.5 rounded-full bg-blue-400 shadow-[0_0_10px_rgba(59,130,246,0.8)]" />
            <span className="absolute top-1/2 right-0 translate-x-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-full bg-cyan-300" />
        </div>
        <div className="absolute inset-16 rounded-full border border-cyan-400/20 bg-cyan-400/[0.04] backdrop-blur" />
        <div className="core-pulse absolute inset-0 m-auto w-24 h-24 rounded-full bg-gradient-to-br from-cyan-400 to-blue-600 flex items-center justify-center">
            <Sparkles className="w-9 h-9 text-white" />
        </div>
    </div>
);

export default function AiEmployee() {
    return (
        <section className="py-24 sm:py-32 relative overflow-hidden" data-testid="employee-section">
            <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-blue-600/[0.07] blur-[140px] rounded-full pointer-events-none" />
            <div className="container-x relative">
                <SectionHead
                    eyebrow="06 — The AI Employee"
                    title="Think of It Like Hiring an Employee."
                    sub="Except this one never sleeps, never forgets, and never lets a lead go cold."
                    testid="employee-heading"
                />
                <div className="mt-16 grid lg:grid-cols-3 gap-6 items-center">
                    <Reveal>
                        <div className="rounded-3xl border border-white/10 bg-white/[0.02] p-8" data-testid="traditional-employee-card">
                            <p className="ff-mono text-xs uppercase tracking-[0.2em] text-slate-500 mb-8">Traditional Employee</p>
                            <ul className="space-y-5">
                                {TRADITIONAL.map((t) => (
                                    <li key={t} className="flex items-center gap-3 text-slate-400">
                                        <X className="w-4 h-4 text-slate-600 shrink-0" />
                                        <span className="text-sm sm:text-base">{t}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </Reveal>

                    <Reveal delay={0.15}>
                        <Avatar />
                    </Reveal>

                    <Reveal delay={0.25}>
                        <div
                            className="rounded-3xl border border-cyan-400/25 bg-cyan-400/[0.05] p-8 relative overflow-hidden"
                            data-testid="ai-employee-card"
                        >
                            <div className="absolute -bottom-16 -left-16 w-48 h-48 bg-cyan-400/10 blur-3xl rounded-full" />
                            <p className="ff-mono text-xs uppercase tracking-[0.2em] text-cyan-300 mb-8">AI Employee</p>
                            <ul className="space-y-5">
                                {AI_EMPLOYEE.map((a) => (
                                    <li key={a} className="flex items-center gap-3 text-white">
                                        <Check className="w-4 h-4 text-cyan-300 shrink-0" />
                                        <span className="text-sm sm:text-base font-medium">{a}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
